<div class="provider-form" [formGroup]="formGroupContainer">
  <mat-form-field>
    <mat-label>Provider</mat-label>
    <input type="text" matInput [formControl]="providerControl" [matAutocomplete]="providerPicker">

    <mat-autocomplete autoActiveFirstOption #providerPicker="matAutocomplete" (optionSelected)="selectProvider($event)"
      [displayWith]="displayProvider">
      <mat-option *ngFor="let provider of filteredProviderList | async" [value]="provider">
        <div class="option">{{ provider.name }}</div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="source-provider-toggle slide-control">
    <mat-slide-toggle formControlName="source_provider"></mat-slide-toggle>
    <mat-label class="slide-label">Source provider</mat-label>
  </div>

  <div class="remove-button-wrapper">
    <button mat-raised-button type="button" color="warn" (click)="removeProviderEntry()">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Remove</span>
    </button>
  </div>
</div>
